const SERIES_BASE_ORDER = [
    "LH_X",
    "LH_Y",
    "LH_Z",
    "LWT_X",
    "LWT_Y",
    "LWT_Z",
    "RH_X",
    "RH_Y",
    "RH_Z",
    "FR_LH_X",
    "FR_LH_Y",
    "FR_LH_Z",
    "FR_RH_X",
    "FR_RH_Y",
    "FR_RH_Z",
    "RR_LH_X",
    "RR_LH_Y",
    "RR_LH_Z",
    "RR_RH_X",
    "RR_RH_Y",
    "RR_RH_Z",
    // HEV 3-mount（seriesDefinitions.ts HEV_SERIES_3MTG と一致）
    "Fr_RH_X",
    "Fr_RH_Y",
    "Fr_RH_Z",
    "Fr_LH_X",
    "Fr_LH_Y",
    "Fr_LH_Z",
    "Rr_X",
    "Rr_Y",
    "Rr_Z",
] as const;

const REGULAR_LEGEND_ORDER_BY_DATASET: Record<string, readonly string[]> = {
    cabin_noise_pred_background: [
        "cabin_noise_target",
        "cabin_noise_pred",
        "background_noise_target",
        "deltaL_target",
    ],
    cabin_noise_target: [
        "cabin_noise_target",
        "background_noise_target",
        "deltaL_target",
    ],
    contribution: SERIES_BASE_ORDER,
    ntf: SERIES_BASE_ORDER,
    mtg_insu: SERIES_BASE_ORDER,
    mtg_vib_ctr: SERIES_BASE_ORDER,
    mtg_vib: SERIES_BASE_ORDER,
    mtg_vib_ctr_target: SERIES_BASE_ORDER,
    mtg_vib_target: SERIES_BASE_ORDER,
};

const END_ORDER_BY_DATASET: Record<string, readonly string[]> = {
    ntf: ["ntf_squared_sum"],
    mtg_insu: ["mtg_insu_squared_sum"],
    mtg_vib_ctr: ["mtg_vib_ctr_squared_sum"],
    mtg_vib: ["mtg_vib_squared_sum"],
    mtg_vib_ctr_target: ["mtg_vib_ctr_target_squared_sum", "mtg_vib_ctr_squared_sum"],
    mtg_vib_target: ["mtg_vib_target_squared_sum", "mtg_vib_squared_sum"],
    cabin_noise_target: ["mtg_vib_target_squared_sum"],
};

function isEndColumnKey(key: string): boolean {
    return key === "rpm" || key === "vel" || key === "index" || key.endsWith("_squared_sum");
}

export function getCsvColumnOrder(
    datasetKey: string,
    dataObj: Record<string, Array<number | null>>
): string[] {
    const keys = Object.keys(dataObj);
    if (keys.length === 0) return [];

    const regularKeys = keys.filter((k) => !isEndColumnKey(k));
    const endKeys = keys.filter((k) => isEndColumnKey(k));

    const preferredRegularOrder = REGULAR_LEGEND_ORDER_BY_DATASET[datasetKey] ?? [];
    const orderedRegular = [
        ...preferredRegularOrder.filter((k) => regularKeys.includes(k)),
        ...regularKeys.filter((k) => !preferredRegularOrder.includes(k)),
    ];

    const preferredEndOrder = [
        ...(END_ORDER_BY_DATASET[datasetKey] ?? []),
        "rpm",
        "vel",
        "index",
    ];
    const orderedEnd = [
        ...preferredEndOrder.filter((k) => endKeys.includes(k)),
        ...endKeys.filter((k) => !preferredEndOrder.includes(k)),
    ];

    return [...orderedRegular, ...orderedEnd];
}
